module.exports = __webpack_public_path__ + "static/img/egg.2feb698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjd_img/egg.png
// module id = r0yT
// module chunks = 46